import { FC, useEffect, useState } from "react";
import { GetCompanies, Company } from "src/apis/company";
import PageContainer from "src/pages/components/PageContainer";
import CompaniesTable from "./components/CompaniesTable";
import { isUserAdministrator } from "src/utils/auth";
import RegisterFab from "src/pages/components/RegisterFab";

const Companies: FC = (): JSX.Element => {
  const [error, setError] = useState<string>('');
  const [companies, setCompanies] = useState<Company[]>([]);

  const fetchData = async (): Promise<void> => {
    try {
      const res = await GetCompanies();

      setCompanies(res.data);
      setError('');
    } catch (err: any) {
      setError(err?.message);
    }
  }

  useEffect(() => {
    fetchData();
  }, [])

  return (
    <PageContainer title="Empresas" error={error} guard={isUserAdministrator}>
      <RegisterFab registerUrl="/empresa/cadastro" />

      <CompaniesTable companies={companies} />
    </PageContainer>
  );
}

export default Companies;
